import { ActionTypes } from "../contants/action-types";

const initialState = {
  jobs: [],
  job: {},
  jobsbyType:[]
};

export const jobsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.FETCH_JOBS:
      return { ...state, jobs: payload };
    case ActionTypes.SET_JOB:
      return { ...state, job: payload };
    case ActionTypes.GET_JOBS_BY_TYPE:
      return { ...state, jobsbyType: payload };
    default:
      return state;
  }
};

// export const selectedProductReducer = (state = {}, { type, payload }) => {
//   switch (type) {
//     case ActionTypes.SELECTED_PRODUCT:
//       return { ...state, ...payload };
//     case ActionTypes.REMOVE_SELECTED_PRODUCT:
//       return {};
//     default:
//       return state;
//   }
// };